<template>
  <Empty
    class="flex-1"
    icon="sli-inbox"
    :title="$t('notifications.empty.title')"
    :description="$t('notifications.empty.description')"
  />
</template>

<script setup>
import { Empty } from "@/shared/ui/empty";
</script>
